import { createContext, useContext, useState } from "react";

const DialogsContext = createContext(null);

export function DialogsProvider({ children }) {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteProfile, setQuoteProfile] = useState(null);
  const [estimatePrefill, setEstimatePrefill] = useState(null);

  const openQuote = (profile = null) => {
    setQuoteProfile(profile);
    setQuoteOpen(true);
  };

  const requestEstimate = (prefill = {}) => {
    const el = document.getElementById("estimation");
    if (el) {
      setEstimatePrefill({ ...prefill, _ts: Date.now() });
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      openQuote(prefill.profile || null);
    }
  };

  return (
    <DialogsContext.Provider
      value={{
        quoteOpen,
        setQuoteOpen,
        quoteProfile,
        openQuote,
        estimatePrefill,
        requestEstimate,
      }}
    >
      {children}
    </DialogsContext.Provider>
  );
}

const NOOP_FALLBACK = {
  quoteOpen: false,
  setQuoteOpen: () => {},
  quoteProfile: null,
  openQuote: () => { window.location.href = "/#estimation"; },
  estimatePrefill: null,
  requestEstimate: () => { window.location.href = "/#estimation"; },
};

export function useDialogs() {
  return useContext(DialogsContext) || NOOP_FALLBACK;
}
